import React from "react";
import { useTranslation } from "react-i18next";
import { useGetInvestigationDetails } from "security-app/hooks/useInvestigationsAPI";
function LoadAssociatedInvestigationsFilterLabel({ invId }) {
  const { t } = useTranslation("enterprise_security_events");
  const { currentInvestigation, loadingInvestigationDetails, fetchError } = useGetInvestigationDetails(invId);
  if (loadingInvestigationDetails) {
    return /* @__PURE__ */ React.createElement("span", null, t("associated_investigations_filter_label.loading"));
  }
  if (fetchError || !currentInvestigation) {
    return /* @__PURE__ */ React.createElement("span", null, t("associated_investigations_filter_label.not_available"));
  }
  return /* @__PURE__ */ React.createElement("span", null, currentInvestigation.name);
}
function AssociatedInvestigationsFilterLabel({ invId }) {
  const { t } = useTranslation("enterprise_security_events");
  if (invId === null || invId === "null") {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, t("associated_investigations_filter_label.none")));
  }
  return LoadAssociatedInvestigationsFilterLabel({ invId });
}
export default AssociatedInvestigationsFilterLabel;
